import { Step, StepValidationState } from "../../../../../interfaces/step";
import { Stepper } from "../../../../../interfaces/stepper";
import { DebtorsComponent } from "../../../../orders/debtors/debtors.component";
import { SecuredPartiesComponent } from "../../../../orders/secured-parties/secured-parties.component";
import { CollateralComponent } from "../../../../orders/collateral/collateral.component";
import { ReviewComponent } from "../../../../orders/review/review.component";
import { QCLienDetailsComponent } from "../../../../orders/lien-details/qc-lien-details/qc-lien-details.component";
import { DealersComponent } from "../../../../orders/dealers/dealers.component";

export class QCRDfLienStepper implements Stepper {

    steps: Step[];

    constructor() {
        this.steps = [
            { title: "Details", content: QCLienDetailsComponent, validationState: StepValidationState.DefaultState },
            { title: "Debtors", content: DebtorsComponent, validationState: StepValidationState.DefaultState },
            { title: "Dealers", content: DealersComponent, validationState: StepValidationState.DefaultState },
            { title: "Sec. Parties", content: SecuredPartiesComponent, validationState: StepValidationState.DefaultState },
            { title: "Collateral", content: CollateralComponent, validationState: StepValidationState.DefaultState },
            { title: "Review", content: ReviewComponent, validationState: StepValidationState.DefaultState }
        ]
    }
}